/* eslint-disable max-len */
import React, { FC } from 'react'
import { CardElement } from 'Pages/landings/newLandings/common/components'
import { useWindowSize } from 'Pages/landings/newLandings/common/hooks'
import rabotaRuWebp from './rabotaRu.webp'
import rabotaRuPng from './rabotaRu.png'
import {
	AccountingIndividualEntrepreneursIcon,
	ElectronicDocIcon,
	LawyerBusinessIcon,
	ReportingGovernmentAgenciesIcon,
} from './Icon'
import {
	Wrapper,
	Title,
	SubTitle,
	List,
	Img,
	ImgPng,
	SubWrapper,
	CardElementStyled,
} from './styled'

export const FreeServicesComponent: FC = () => {
	const { width } = useWindowSize()
	return (
		<Wrapper>
			<Title>Бесплатные сервисы для&nbsp;вашего бизнеса</Title>
			<SubTitle>
				За 0 ₽ навсегда при&nbsp;подключении СберБизнес Прайм или&nbsp;Пакета услуг
			</SubTitle>
			<List>
				<CardElement
					title="Бухгалтерия для ИП на 6%"
					subTitle="Поможет подготовить все&nbsp;документы, вам&nbsp;останется только их&nbsp;отправить"
				>
					<AccountingIndividualEntrepreneursIcon />
				</CardElement>
				<CardElement
					title="Юрист для бизнеса"
					subTitle="Проконсультирует по&nbsp;личным и&nbsp;бизнес-вопросам, проведёт переговоры за&nbsp;вас"
				>
					<LawyerBusinessIcon />
				</CardElement>
				<CardElement
					title="Электронный документооборот"
					subTitle="Позволит моментально обмениваться юридически значимыми документами"
				>
					<ElectronicDocIcon />
				</CardElement>
				{width > 1024 ? (
					<SubWrapper>
						<CardElement
							title="Вакансия на Работа.ру"
							subTitle="Вы сможете бесплатно разместить вакансию и&nbsp;поменять текст неограниченное количество&nbsp;раз"
						>
							<Img srcSource={rabotaRuWebp}>
								<ImgPng src={rabotaRuPng} alt="" />
							</Img>
						</CardElement>

						<CardElement
							title="Отчетность в госорганы"
							subTitle="Автоматически проверит отчётность перед&nbsp;отправкой в&nbsp;ФНС, СФР&nbsp;и&nbsp;Росстат"
						>
							<ReportingGovernmentAgenciesIcon />
						</CardElement>
					</SubWrapper>
				) : (
					<>
						<CardElement
							title="Вакансия на Работа.ру"
							subTitle="Вы сможете бесплатно разместить вакансию и&nbsp;поменять текст неограниченное количество&nbsp;раз"
						>
							<Img srcSource={rabotaRuWebp}>
								<ImgPng src={rabotaRuPng} alt="" />
							</Img>
						</CardElement>

						<CardElementStyled
							title="Отчетность в госорганы"
							subTitle="Автоматически проверит отчётность перед&nbsp;отправкой в&nbsp;ФНС, СФР&nbsp;и&nbsp;Росстат"
						>
							<ReportingGovernmentAgenciesIcon />
						</CardElementStyled>
					</>
				)}
			</List>
		</Wrapper>
	)
}
